/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
/* eslint-disable no-multi-spaces */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
import {Account, AccountLink, Entity, GenericObject} from './entities';

export interface GenericFunction<T> {
  (arg: T): T;
};

// defines a union of primitive types ...
export type Primitive = boolean | string | number;

// defines union type for date parameter
export type DateTime = string | Date | number;

// defines display position of the map which is a latitude and
// longitude, also radius is optional
export type MapPosition = [number, number] | [number, number, number];

/**
 * A map enum for the checked state of a mui input as well as the checked state
 * of a account filter in the checkbox tree.
 */
export enum CheckboxState {
  Unchecked = 0,
  Checked = 1,
  Indeterminate = 2
};

export interface Column {
  id: string;
  label: string;
  format?: (value: number) => string;
}

export type YES_NO = 'yes' | 'no';

/**
 * A map enum for a user's saved preferences:
 * 'Device' | 'SI' | 'Metric' | 'US' | 'Mixed'
 *
 *  and the accepted units by ArcGIS:
 * 'non-metric' | 'metric' | 'dual'
 */
export enum SystemOfUnitsMap {
  Device   = 'non-metric',
  US       = 'non-metric',
  Imperial = 'non-metric',
  SI       = 'metric',
  Metric   = 'metric',
  Mixed    = 'dual'
}

/**
 * A map enum for a user's saved preferences:
 * 'Device' | 'SI' | 'Metric' | 'US' | 'Mixed'
 *
 *  and the accepted linear units by ArcGIS for creating shapes
 *  'meters' | 'feet' | 'kilometers' | 'miles' | 'nautical-miles' | 'yards'
 */
export enum LinearUnitsMap {
  Device   = 'feet',
  US       = 'feet',
  Imperial = 'feet',
  SI       = 'meters',
  Metric   = 'meters',
  Mixed    = 'meters'
}

/**
 * the potential modes an editor might be in
 * so we can properly show (or not show) the
 * correct data
 */
export enum EditorModes {
  View = 'view',
  Edit = 'edit',
  Add  = 'add'
}

// Bulk search terms object type
export interface SearchTerm {
  [key: string]: {
    value     : string;
    wildcard? : boolean;
  };
}

export interface PartitionBulkUpdates {
  uploaded      : Array<GenericObject>,
  searched      : Array<GenericObject>,
  entity        : Entity,
  key?          : string | string[],
  excludeAttrs? : boolean,
  validator?    : Function | null
}

export type VoidEventHandler = (event : unknown) => void;

/**
 * Accounts Search valid include values as per CTC
 */
export enum AccountsSearchIncludes {
  extensions = 'extensions',
  extAttribs = 'extAttribs',
};

/**
 * Available date ranges ...
 */
export enum DateRange {
  default = 'Date_Range',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year'
};

export interface FilteredAccount extends AccountLink {
  path?: string[];
  weight?: number;
  accountId?: string;
}

export interface FilteredAccounts {
  item: FilteredAccount;
  matches: any;
}

export enum TemperatureType {
  Celsius = 'celsius',
  Fahrenheit = 'fahrenheit'
}

export enum TemperatureUnit {
  Celsius = '°C',
  Fahrenheit = '°F'
};

export enum SensorUnitType {
  GForce = 'G',
  Tilt = 'Deg'
}

export interface GlobalGroupProps {
  globalGroup?: Account;
  accountMap?: GenericObject;
}

export enum Operation {
  Create = 'create',
  Update = 'update',
  Read   = 'read',
  Delete = 'delete',
  Assign = 'assign',
  Self   = 'self'
}

export enum RequestTypeLabels {
  DEVICE = 'device',
  USER   = 'user',
  ASSET  = 'asset',
  OTHER  = 'other',
  ENABLESERVICES = 'enableServices',
  SERVICEENABLEMENT = 'serviceEnablement'
};

export enum RequestTypes {
  device = 'devices',
  user   = 'users',
  asset  = 'assets',
  other  = 'other'
};
